import React from "react";
import image from "../images/hands.jpg";
import styled from "styled-components";

const Extra = () => {
  return (
    <Container>
      <img src={image} alt="" />
      <div>
        <h1>Tratamento para Dependentes Químicos e Alcoolismo </h1>
        <div></div>
        <p>
          A Clínica Mendes & Herrero é uma organização altamente experiente em
          oferecer suporte, direcionamento e assistência para internação e
          tratamento de pessoas com dependência química, além de fornecer ajuda
          aos familiares desses pacientes.
          <br /> Reconhecida no segmento, a empresa dispõe de grandes centros de
          tratamento para drogas, alcoolismo e comorbidades, e tem alcançado
          excelentes resultados em recuperação graças aos seus programas
          terapêuticos específicos para homens e mulheres.
        </p>
      </div>
    </Container>
  );
};
export default Extra;

const Container = styled.div`
  min-height: 500px;
  height: auto;
  padding-top: 50px;
  padding-bottom: 50px;
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    height: 250px;
    border-radius: 3px;
    object-fit: fill;
  }
  div {
    margin-left: 15px;

    width: 22%;
    font-family: "Jost", sans-serif;
    display: column;

    h1 {
      font-size: 2rem;
      line-height: 1.28571;
      color: #3d73a3;
      margin-bottom: 10px;
    }
    div {
      margin-left: 5px;
      width: 100px;
      height: 3px;
      border-radius: 5px;
      background-color: #537bae;
      margin-bottom: 20px;
    }
    p {
      font-size: 1rem;
      line-height: 1.5;
      color: #000000b8;
    }
  }
  @media (max-width: 1500px) {
    div {
      width: 40%;
    }
  }
  @media (max-width: 900px) {
    flex-wrap: wrap;

    div {
      width: 50%;
    }
  }
  @media (max-width: 900px) {
    div {
      width: 90%;
    }
  }
  @media (max-width: 450px) {
    img {
      width: 90%;
      height: auto;
    }
  }
`;
